import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const edgeMedium172100Raw = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  aspectRatio: 1.72,
  type: 'Image172x100',
  associationType: 'ImageMedia172X100',
  imagePreviewHeight: 174,
  minimumRequirements: 0,
  minSize: [300, 174],
  localizedText: {
    previewTypeStringKey: _TL_('Microsoft Edge medium headline'),
    stringKey: _TL_('1.72 : 1'),
    disclaimerMessage: _TL_('This is an example of how your ad could appear on other websites on the Microsoft Advertising Network. The final ad format is likely to change to match the look and feel of the website.'),
  },
  previewSettings: {
    showAdsLabelWithBusinessName: true,
    showBusinessName: true,
    showImage: true,
    showLongHeadline: true,
    showGradient: true,
    showMultipleLineLongHeadline: true,
  },
  styleOverrides: {
    businessNameWithAds: {
      '& .business-name': {
        fontSize: 11,
        lineHeight: '1.364',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      '& .adslabel': {
        fontSize: 10,
        lineHeight: '1.364',
        margin: '0 5px 0 0',
        background: 'transparent',
        borderRadius: 4,
        color: '#fff',
        fontFamily: '"Segoe UI","Segoe WP",Arial,Sans-Serif',
        fontWeight: 400,
        padding: '.8px 4px',
        border: '.5px solid hsla(0,0%,100%,.3)',
        opacity: 0.7,
      },
    },
    longHeadline: {
      fontSize: 10,
      lineHeight: '16px',
    },
    previewContent: {
      height: 250,
      backgroundColor: 'rgb(46, 46, 46)',
    },
    textContainer: {
      position: 'absolute',
      color: '#bebebe',
      bottom: 25,
      left: 20,
      fontSize: 10,
      lineHeight: '16px',
    },
    gradient: {
      '&:after': {
        display: 'block',
        position: 'relative',
        backgroundImage: 'linear-gradient(to bottom, transparent 0, rgb(46, 46, 46) 100%)',
        marginTop: -279,
        height: 280,
        width: '100%',
        content: '\'\'',
      },
    },
  },
};

export default edgeMedium172100Raw;
